// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"UniversalButton_loadingContainer__3fRWo","heading":"UniversalButton_heading__96Q3m"};